import { useMutation } from '@tanstack/react-query';
import { updateComment } from '../queries/comments';

const useUpdateComment = () => {
  const { mutate, isPending, isSuccess } = useMutation({
    mutationKey: ['update-comment'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      updateComment(id, data),
  });

  return { updateComment: mutate, isPending, isSuccess };
};

export default useUpdateComment;
